import { FormlyFieldConfig } from '@ngx-formly/core';

export interface IRepeaterIndexKeys {
  repeaterParentKey: string;
  itemIndex: number;
}

export const getParentRepeaterKeyAndItemIndex = (
  field: FormlyFieldConfig
): IRepeaterIndexKeys | undefined => {
  let repeaterIndexKeys: IRepeaterIndexKeys | undefined = undefined;
  let parentField: FormlyFieldConfig | undefined = field?.parent;
  while (parentField) {
    if (
      (parentField?.key !== undefined &&
        Number.parseInt(<string>parentField?.key) >= 0 &&
        parentField?.parent?.type === 'customrepeater') ||
      parentField?.parent?.type === 'repeater'
    ) {
      repeaterIndexKeys = {
        repeaterParentKey: <string>parentField?.parent?.key,
        itemIndex: <number>parentField?.key,
      };
      break;
    }
    parentField = parentField?.parent;
  }
  return repeaterIndexKeys;
};
